// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "InlineNotification-module--cds--assistive-text--dYYRD";
export var cdsVisuallyHidden = "InlineNotification-module--cds--visually-hidden--RCsMV";
export var darkMode = "InlineNotification-module--darkMode--DAPBN";
export var hideFeedback = "InlineNotification-module--hide-feedback--qjoxr";
export var notification = "InlineNotification-module--notification--iBRvr";
export var showFeedback = "InlineNotification-module--show-feedback--NARfp";
export var skeleton = "InlineNotification-module--skeleton--jS4bk";